module.exports = __webpack_public_path__ + "static/media/img2-1.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/limon/nutricheck_foliar/P/img2-1.png
// module id = 1676
// module chunks = 3